import Accordion from "./Accordion";
import type { AccordionAdapterProps } from "./Accordion.d";

export { Accordion };
export type { AccordionAdapterProps };
